<template>
  <div class="field-item">
    <span class="field-item-title single-ellipsis" v-if="showFieldTitle">
      <span>{{ entityDetail.fieldDetail.title }}：</span>
    </span>
    <div
      ref="contentRef"
      class="field-item-content single-ellipsis theme-content"
      :class="[isInvalid ? 'field-invalid' : entityDetail.fieldDetail.fieldThemeName, showTools ? 'have-tool' : '']"
    >
      <div class="single-ellipsis">
        <el-tooltip effect="light" :disabled="!entityDetail.tagContent" placement="top" :open-delay="300">
          <div slot="content" class="normal-tooltip-content">{{ entityDetail.tagContent }}</div>
          <span>{{ entityDetail.text || '-' }}</span>
        </el-tooltip>
      </div>

      <el-popover
        ref="updPopover"
        placement="top"
        trigger="manual"
        @show="editorShowed = true"
        @hide="editorShowed = false"
      >
        <span class="upd-popover-popover" slot="reference"></span>
        <div class="field-value-editor-content" :style="{ padding: '12px' }">
          <el-input-number
            v-if="entityDetail.fieldDetail.type === 'num'"
            :style="{ width: '160px' }"
            placeholder="请输入"
            v-model="fieldVal"
            :precision="2"
            :controls="false"
          />
          <el-date-picker
            v-if="entityDetail.fieldDetail.type === 'date'"
            :style="{ width: '160px' }"
            placeholder="选择日期时间"
            popper-class="field-date-picker-content"
            v-model="fieldVal"
            type="date"
            :clearable="false"
          />

          <el-button :style="{ marginLeft: '10px' }" type="text" @click="changeFieldVal()">
            <span>确定</span>
          </el-button>
          <el-button type="text" @click="closeEditorHandle()">取消</el-button>
        </div>
      </el-popover>

      <el-dropdown class="tool-btn" placement="top" @command="commandHandle" v-if="showTools">
        <div class="tool-icon">
          <i class="iconfont icongengduo"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="clear">
            <i class="iconfont iconcha" :style="{ fontSize: '12px' }"></i>
            <span>移除标注</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="entityDetail.fieldDetail.type === 'num'" command="updVal">
            <i class="el-icon-edit"></i>
            <span>修改数值</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="entityDetail.fieldDetail.type === 'date'" command="updVal">
            <i class="el-icon-edit"></i>
            <span>修改日期</span>
          </el-dropdown-item>
          <el-dropdown-item command="updRelation" v-if="couldUpdRelation">
            <i class="el-icon-edit"></i>
            <span>修改关联关系</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      fieldVal: '',
      editorShowed: false
    };
  },
  props: {
    entityDetail: {
      type: Object,
      required: true
    },
    couldUpdRelation: {
      type: Boolean,
      default: false
    },
    showTools: {
      type: Boolean,
      default: true
    },
    showFieldTitle: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  beforeDestroy() {
    window.document.removeEventListener('mouseup', this.checkTapPosition);
  },
  created() {
    window.document.addEventListener('mouseup', this.checkTapPosition);
  },
  methods: {
    checkTapPosition(event) {
      if (!this.editorShowed) {
        return;
      }
      const parentNodeArr = [event.target];
      let index = 0;
      while (index < parentNodeArr.length) {
        const item = parentNodeArr[index];
        const { className = '' } = item;
        if (className.includes('field-value-editor-content') || className.includes('field-date-picker-content')) {
          return;
        }
        if (item.parentNode) {
          parentNodeArr.push(item.parentNode);
        }
        index++;
      }

      this.closeEditorHandle();
    },
    closeEditorHandle() {
      this.$refs.updPopover.doClose();
    },
    async commandHandle(action) {
      if (action === 'clear') {
        await this.$confirm(`是否移除该标注或关联?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        this.$emit('clear');
      }
      if (action === 'updRelation') {
        this.$emit('updRelation', this.$refs.contentRef.getBoundingClientRect());
      }
      if (action === 'updVal') {
        this.setFieldValHandle();
        this.$refs.updPopover.doShow();
      }
    },
    changeFieldVal() {
      let val = this.fieldVal;
      if (this.entityDetail.fieldDetail.type === 'date' && val) {
        val = dayjs(val).valueOf();
      }
      this.$emit('changeFieldVal', val);
      this.closeEditorHandle();
    },
    setFieldValHandle() {
      let fieldVal = this.entityDetail.fieldVal;

      if (!fieldVal) {
        if (this.entityDetail.fieldDetail.type === 'num') {
          fieldVal = 0;
        }
        if (this.entityDetail.fieldDetail.type === 'date') {
          fieldVal = dayjs();
        }
      }

      this.fieldVal = fieldVal;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../index';

.tool-btn {
  color: inherit;
  .tool-icon {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      color: inherit;
    }
  }
}
</style>
